import React, { useEffect, useState, useContext } from "react";
import Tab from "../tab/tab";
import TopBar from "../../scenes/global/Top-Bar";
import SideBar from "../../scenes/global/Side-Bar";
import BasicSelect from "../select/select";
import Radio from "../radio/radio";
import AddedItem from "../added_item/added_item";
import ViewProp from "../view_prop/view";
import AddMore from "../add_more/add_more";
import Months from "../../scenes/step/data/month";
import { useSelector, useDispatch } from "react-redux";
import { dispatchEducation, updateEducation, saveEducation } from "../../Redux/ActionCreator";
import $ from "jquery";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { convertEducation } from "../../Redux/convertResume";
//import language context
import { LanguageContext } from "../../scenes/global/languageContext";
import dayjs from "dayjs";

export default function UserEducation(props) {
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const dispatch = useDispatch();
  const educ = useSelector(edu => edu.education);
  const existingCv = useSelector(e => e.existingCV);
  const generated = useSelector(e => e.generateCV);
  const cv = useSelector(prev => prev.cvId);
  const message = existingCv.message;
  const profile = useSelector(e => e.profile);
  const [ isRedux, setRedux ] = useState(false);
  let [ education, setEducation ] = useState(props.education);
  let [ chips, setChips ] = useState(props.education);
  const [ startDateValue, setStartDateValue ] = useState("");
  const [ endDateValue, setEndDateValue ] = useState("");
  const [ startDateValue1, setStartDateValue1 ] = useState("");
  const [ endDateValue1, setEndDateValue1 ] = useState("");
  const secret = useSelector(prev => prev.secret);
  const userInfo = useSelector(e => e.userInfo);
  const profile1 = useSelector(e => e.login);
  let stat = profile1.profile_status.profile_status
  const [ present, setPresent ] = useState(false);
  console.log("education", education);
  console.log("chips", chips);
  let [ path, setPath ] = useState(false)
  const [ obj, setObj ] = useState();
  const [ newEdu, setNewEdu ] = useState();
  let [ degreeState, setDegreeState ] = useState("");
  let [ back, setBack ] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (
      window.location.pathname === "/user/profile/update/education" &&
      profile.message !== null
    ) {
      setPath(true);
      setChips(profile.message.Education);
      setEducation(profile.message.Education);
    } else if (window.location.pathname === `/form/${cv.id}/update`) {
      setChips(generated.message.Education);
      setEducation(generated.message.Education);
    } else {
      if (educ.education !== null) {
        setChips(educ.education);
        setEducation(educ.education)
      } else if (message !== null) {
        if (message.Education !== null) {
          setChips(message.Education);
          setEducation(message.Education);
        } else {
          setChips([]);
          setEducation([]);
        }
      }
    }

    if (message !== null) {
      setRedux(true);
    }
  }, []);
  
  useEffect(() => {
    if (obj !== undefined) {
      dispatch(generate_my_cv(obj));
    }

    if (newEdu !== undefined) {
      dispatch(updateEducation(education));
    }
  }, [obj, newEdu])


  useEffect(() => {
    $('input[name="present"]').on("click", () => {
      setPresent(!present)
      if (present === true) {
        $('#present').prop('checked', false);
      } else {
        $('#present').prop('checked', true);
      }
    });
  }, [present]);
  console.log("Edu_present", present)
/*   useEffect(() => {
    if (back == true) {
      console.log("Back was called.")
      $('#present').prop('checked', false);
    }
  }, [back]) */
  

  const handleSaveAndContinue = (event) => {
    event.preventDefault();
/*  
    if (window.location.pathname === "/user/profile/update/education" && profile.message !== null) {
    if (
      window.location.pathname === "/user/profile/update/education" &&
      profile.message !== null
    ) {
      // do sth here
      dispatch(updateEducation(education));
    } else {
      dispatch(dispatchEducation(education));
    }
    /* dispatch(personal_information(personal_data)); */
  };

  let mth = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"]

  const handleClickOperation = (arg) => {
    if (
      window.location.pathname === "/user/profile/update/education" &&
      profile.message !== null
    ) {
      // do sth here
      const desiredObject = education.find((item) => item._id == arg._id);
      console.log("desired object edu", desiredObject);
      let e = education.filter((chip) => chip._id !== desiredObject._id);
      e.forEach((element) => {
        element._id = e.indexOf(element); // change the element key to their index number in the new eduction variable `e`;
        console.log("edu new key", e.indexOf(element));
      });

       var name = desiredObject.School;  
       let startMonth;
       let startYear
       if (desiredObject.Start_date !== null && desiredObject !== undefined) {
        startMonth = desiredObject.Start_date.split(" ")[0];
        startYear = desiredObject.Start_date.split(" ")[1];
        const firstMonth = new Date(startYear, mth.indexOf(startMonth));
        const firstYear = new Date(startYear);
        let i = firstMonth.getTime();
        let y = firstYear.getTime();
        console.log("Milli", i);
        console.log("Mil year", y);
        setStartDateValue(i);
        setEndDateValue(y);
      }
      let endYear, endMonth;
      if (
        desiredObject.End_date !== null &&
        desiredObject.End_date !== undefined
      ) {
        if (desiredObject.End_date === "Present") {
          $('#present').prop('checked', true);
          setPresent(true);
        } else {
          setPresent(false);
          $('#present').prop('checked', false);
          endMonth = desiredObject.End_date.split(" ")[0];
          endYear = desiredObject.End_date.split(" ")[1];
          const secondMonth = new Date(endYear, mth.indexOf(endMonth));
          const secondYear = new Date(endYear);
          let sm = secondMonth.getTime();
          let sy = secondYear.getTime();
          console.log("sm", sm);
          console.log("sy", sy);
          setStartDateValue1(sm);
          setEndDateValue1(sy);
        }
      }

      console.log(startMonth, startYear, endMonth, endYear);

      $('[name="school"]').val(name);
      setDegreeState(desiredObject.Degree);
      $('[name="course"]').val(desiredObject.Course);
      $('[name="award"]').val(desiredObject.Award);

      if (isRedux === true) {
        $('[name="course"]').val(desiredObject.Deree);
        $('[name="startDate"]').val(desiredObject.Start_date);
        $('[name="endDate"]').val(desiredObject.End_date);
      } else {
        $('[name="course"]').val(desiredObject.Course);
        $('[name="levelType"]').val(desiredObject.Degree);
      }

      console.log(desiredObject);
      setEducation(e);
      setChips(e);
      console.log("inner education", e);
    } else {
      const desiredObject = education.find((item) => item.key === arg.key);
      console.log("desired object edu", desiredObject);
      let e = education.filter((chip) => chip.key !== desiredObject.key);
      e.forEach((element) => {
        element.key = e.indexOf(element); // change the element key to their index number in the new eduction variable `e`;
        console.log("edu new key", e.indexOf(element));
      });

      var name = desiredObject.School;
      let startMonth;
      let startYear;
      if (desiredObject.Start_date !== null && desiredObject !== undefined) {
        startMonth = desiredObject.Start_date.split(" ")[0];
        startYear = desiredObject.Start_date.split(" ")[1];
        const firstMonth = new Date(startYear, mth.indexOf(startMonth));
        const firstYear = new Date(startYear);
        let i = firstMonth.getTime();
        let y = firstYear.getTime();
        console.log("Milli", i);
        console.log("Mil year", y);
        setStartDateValue(i);
        setEndDateValue(y);
        // setEndDateValue(startYear)
      }
      let endYear, endMonth;
      if (
        desiredObject.End_date !== null &&
        desiredObject.End_date !== undefined
      ) {
        if (desiredObject.End_date === "Present") {
          $('#present').prop('checked', true);
          setPresent(true);
        } else {
          setPresent(false);
          $('#present').prop('checked', false);
          endMonth = desiredObject.End_date.split(" ")[0];
          endYear = desiredObject.End_date.split(" ")[1];
          const secondMonth = new Date(endYear, mth.indexOf(endMonth));
          const secondYear = new Date(endYear);
          let sm = secondMonth.getTime();
          let sy = secondYear.getTime();
          console.log("sm", sm);
          console.log("sy", sy);
          setStartDateValue1(sm);
          setEndDateValue1(sy);
        }
      }

      console.log(startMonth, startYear, endMonth, endYear);

      $('[name="school"]').val(name);
      setDegreeState(desiredObject.Degree);
      $('[name="course"]').val(desiredObject.Course);
      $('[name="award"]').val(desiredObject.Award);

      if (isRedux === true) {
        $('[name="course"]').val(desiredObject.Degree);
        $('[name="startDate"]').val(desiredObject.Start_date);
        $('[name="endDate"]').val(desiredObject.End_date);
      } else {
        $('[name="course"]').val(desiredObject.Course);
        $('[name="levelType"]').val(desiredObject.Degree);
      }

      console.log(desiredObject);
      setEducation(e);
      setChips(e);
      console.log("inner education", e);
    }
  };

  const handleClick = (edu) => {
    if ($('[name="school"]').val() !== "") {
      handleAdd();
      handleClickOperation(edu);
    } else {
      handleClickOperation(edu);
    }
  };

  const handleEduNext = () => {
    if (window.location.pathname === "/user/profile/update/education" && profile.message !== null) {
      if ($('[name="school"]').val() !== "" || $('[name="course"]').val() !== "") {
        handleAdd();
      }
        dispatch(dispatchEducation(education));
        dispatch(updateEducation(education));
      navigate(`/user/profile/:${userInfo.user.profile_id}`);
    } else if (window.location.pathname === `/form/${cv.id}/update`) {
      if ($('[name="school"]').val() !== "") {
        handleAdd();
        dispatch(dispatchEducation(education));
      }
      let generated_value = generated.message;
      generated_value.Education = educ.education;
      dispatch(dispatchEducation(education));
      setObj(generated_value);
      navigate("/allCv");
    } else {
      if ($('[name="school"]').val() !== "") {
        setTimeout(() => {
          toast.error("Add the education you just filled.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      } else {
        console.log("Called education", education)
        dispatch(dispatchEducation(education));
        if (stat === "false" || stat === false) {
          dispatch(saveEducation(education, secret.secret));
        }
        props.handleStepChange();
      }
    }
  };

  const handlePreviousBTN = () => {
    if ($('[name="school"]').val() !== "") {
      setTimeout(() => {
        toast.error("Add the education you just filled.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
    } else {
      props.handleStepChangeBack();
    }
  }
  const handleDelete = (edu) => {
    if (window.location.pathname === "/user/profile/update/experience" && profile.message !== null) {
      const temp_edu = education.filter((ed) => ed._id !== edu._id);
      // correct remaining education key
      temp_edu.forEach((element) => {
        element._id = temp_edu.indexOf(element);
      });
      setEducation(temp_edu);
      setChips(temp_edu);
      dispatch(dispatchEducation(temp_edu));
    }
    const temp_edu = education.filter((ed) => ed.key !== edu.key);
    // correct remaining education key
    temp_edu.forEach((element) => {
      element.key = temp_edu.indexOf(element);
    });
    setEducation(temp_edu);
    setChips(temp_edu);
    dispatch(dispatchEducation(temp_edu));
  };

  // handleAdd
  const handleAdd = () => {
    if ($('[name="school"]').val() == "") {
      setTimeout(() => {
        toast.error("Please fill form field before you can add.", {
            position: toast.POSITION.TOP_RIGHT,
        });
    }, 50);
    } else {
      let temp_edu = education;
    var school =  $('[name="school"]').val();
    var Degree = degreeState;
    var Course = $('[name="course"]').val();
    var Start_date;
    var End_date;
    var Award = $('[name="award"]').val();

    const date1 = new Date(startDateValue);
    const date2 = new Date(endDateValue);

    const date3 = new Date(startDateValue1);
    const date4 = new Date(endDateValue1);

    const month1 = date1.toLocaleDateString("en-US", { month: "short" });
    const year1 = date2.getFullYear();

    const month2 = date3.toLocaleDateString("en-US", { month: "short" });
    const year2 = date4.getFullYear();

    if (isRedux == true) {
      Start_date = $('[name="startDate"]').val();
      if (present == true) {
        End_date = "Present";
      } else {
        End_date = $('[name="endDate"]').val()
      }
    } else {
      Start_date = month1 + " " + year1;
      if (present == true) {
        End_date = "Present";
      } else {
        End_date =  month2 + " " + year2;
      }
    }

    const k = education.length + 1;
    const educational_data = {
      key: k,
      School: school,
      Degree: Degree,
      Course: Course,
      End_date: End_date,
      Start_date: Start_date,
      Award: Award,
    };
    console.log("educational data", educational_data);
    temp_edu.push(educational_data);
    if (window.location.pathname === "/user/profile/update/experience" && profile.message !== null) {
      setNewEdu(temp_edu);
    }
    setEducation(temp_edu);
    setChips(education);
    dispatch(dispatchEducation(education));
    console.log("Education inner", education);
    // after adding to education, then return all fields back to null.
    $('[name="school"]').val("");
    setDegreeState("");
    setStartDateValue("");
    setEndDateValue("");
    setStartDateValue1("")
    setEndDateValue1("");
    $('#present').prop("checked", false);
    setPresent(false);
    $('[name="course"]').val("");
    $('[name="startDate"]').val("");
    $('[name="endDate"]').val("");
    $('[name="award"]').val(""); 
    }

  }

  return (
    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar />
      <div className="px-3 lg:pl-6 my-8 w-full">
        <div className="w-full max-w-[793px] h-[54px] bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 flex flex-col justify-center">
          <p className="text-stone-950 text-base md:text-[28px] font-semibold ml-12 max-[300px]:ml-6">
            {language["resume_caph1"]}
          </p>
        </div>
        <p className="w-full max-w-[741px] text-[14px] md:text-base mt-2 px-3 lg:pl-6">
          {language["fillform_tab2"]}{" "}
          <span className="text-orange-500 text-[14px] md:text-basefont-medium">
            {language["usedfor_creating"]}
          </span>
        </p>
        <div className="max-w-[800px] w-full mt-8 p-8 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 flex-col justify-start items-start gap-16 inline-flex">
          <div className="tabarea justify-start items-center gap-6 inline-flex w-full flex-shrink-0 w-full max-w-[calc(100vw-88px)] overflow-hidden">
            <Tab num="1" current={false} completed={true} />
            <Tab
              // label="Education"
              label={`${language["education_tab2"]}`}
              current={true}
              completed={false}
            />
            <Tab num="3" current={false} completed={false} />
            <Tab num="4" current={false} completed={false} />
            <Tab num="5" current={false} completed={false} />
            <Tab num="6" current={false} completed={false} />
            <Tab num="7" current={false} completed={false} />
            <Tab num="8" current={false} completed={false} />
            <Tab num="9" current={false} completed={false} />
          </div>
          {message !== undefined && message !== null ? 
        <div className='sm:mt-2 mb-4 py-2 px-4 sm:mb-2 sm:py-0'>
            <h6 className='top-2 text-[24px] text-pry-920 sm:text-sm'>{language["text"]}</h6>
        </div> : null}
            <div className="flex-col justify-start items-start gap-12 flex w-full">
              <div className="flex-col justify-start items-start gap-2 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="school"
                  >
                    {language["where_school"]}
                  </label>
                </div>
                <input
                  type="text"
                  className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                  placeholder={`${language["your_school_p"]}`}
                  id="school"
                  name="school"
                />
              </div>
              <div className="flex-col justify-start items-start gap-2 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="levelType"
                  >
                    {language["education_level"]}
                  </label>
                </div>
                <div className="w-full h-[54px] flex">
                  <BasicSelect
                    placeholder={`${language["level_place"]}`}
                    labelId="level"
                    selectMenu="levelType"
                    value={degreeState}
                    id="levelType"
                    onChange={(event) => (setDegreeState(event.target.value))}
                    menuItems={["No Formal Education", "Primary Education", "Secondary Education", "Vocational/Technical Training", "Some College", "Associate Degree", "Bachelor's Degree", "Master's Degree", "PHD"]}
                  />
                </div>
              </div>
              <div className="flex-col justify-start items-start gap-2 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="course"
                  >
                    {language["degree_gotten"]}
                  </label>
                </div>
                <div className="w-full h-[54px] flex">
                  <input
                    type="text"
                    className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                    placeholder={`${language["enter_degree_p"]}`}
                    id="course"
                    name="course"
                  />
                </div>
              </div>
              <div className="flex-col justify-start items-start gap-2 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="startDate"
                  >
                    {language["start_studies"]}
                  </label>
                </div>
                {message !== null ? null : 
                <p className="text-zinc-400 text-base font-medium">
                  {language["select_month_year"]}
                </p>
                }
                {isRedux === true ? (
                  <div className="flex-col justify-start items-start gap-2 flex w-full">
                    <div className="flex gap-3 items-center"></div>
                    <div className="w-full h-[54px] flex">
                      <input
                        type="text"
                        className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                        placeholder={`${language["fm2_dates"]}`}
                        id="StartDate"
                        name="startDate"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="w-full flex flex-col sm:flex-row gap-2">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker", "DatePicker", "DatePicker"]}
                      >
                        <DatePicker
                          label={`${language["month_place"]}`}
                          views={["month"]}
                          value={dayjs(startDateValue)}
                          onChange={(event) => setStartDateValue(event)}
                          sx={{ borderColor: 'black' }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker", "DatePicker", "DatePicker"]}
                      >
                        <DatePicker
                          label={`${language["year_place"]}`}
                          name="startYear"
                          views={["year"]}
                          value={dayjs(endDateValue)}
                          onChange={(endValue) => setEndDateValue(endValue)}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>)
              }
              </div>
              <div className="flex-col justify-start items-start gap-2 flex w-full">
                <div className="flex gap-3 items-center">
                  <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                  <label
                    className="text-black text-base font-medium"
                    for="endDate"
                  >
                    {language["finish_studies"]}
                  </label>
                </div>
                {message !== null ? null :
                <p className="text-zinc-400 text-base font-medium">
                  {language["set_end_month"]}
                </p>
                }
                
                {isRedux === true ? (
                  <div className="flex-col justify-start items-start gap-2 flex w-full">
                    <div className="flex gap-3 items-center"></div>
                    <div className="w-full h-[54px] flex">
                      <input
                        type="text"
                        className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                        placeholder={`${language["fm2_dates"]}`}
                        id="endDate"
                        name="endDate"
                      />
                    </div>
                  </div>) : 
                  <>
                  {present === true ? null : 
                  <div className="w-full flex flex-col sm:flex-row gap-2">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}>
                    <DatePicker
                          label={`${language["month_place"]}`}
                        views={['month']}
                        value={dayjs(startDateValue1)}
                        onChange={(event) => setStartDateValue1(event)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}>
                      <DatePicker 
                          label={`${language["year_place"]}`}name="endYear" views={[ 'year']}
                          value={dayjs(endDateValue1)} 
                          onChange={(endValue) => setEndDateValue1(endValue)} />
                    </DemoContainer>
                  </LocalizationProvider>
                  </div>
                  }
                  <Radio name="present" label="Present" id="present" />
                  </>
                }
              </div>
              {/* <div className="w-full h-[54px] flex gap-2">
                  <BasicSelect
                    placeholder="Month"
                    labelId="matric"
                    selectMenu="endMonth"
                    id="endDate"
                    menuItems={[ ...month ]}
                  />
                  <BasicSelect
                    placeholder="Year"
                    labelId="graduation"
                    selectMenu="endYear"
                    id="endDate"
                    menuItems={[ ...year ]}
                  />
                </div> */}
              <div className="w-full">
                <div className="flex flex-col gap-3">
                  <label
                    className="text-black text-base font-medium"
                    for="hasAward"
                  >
                    {language["special_recogn"]}
                  </label>
                  {/* <div className="flex gap-3">
                    <Radio name="hasAward" label="No" id="" />
                    <Radio name="hasAward" label="Yes" id="" />
                  </div> */}
                  <input
                  type="text"
                  className="p-4 w-full rounded-lg border border-indigo-400 border-opacity-30"
                  placeholder={`${language["award_here_place"]}`}
                  id="award" name="award"
                />
                <div className="flex-col justify-start items-start gap-3 flex w-full">
                  <AddMore text="education" onClick={handleAdd} />
                  <p className="text-black text-base font-medium">
                      {language["have_added"]}
                  </p>
                  <div className="flex flex-wrap gap-3">
                    {chips?.map((edu, key) => (
                      <AddedItem item={edu.School} key={key} onClick={() => handleClick(edu)} delete={() => handleDelete(edu)} />
                    ))}
                  </div>
                  {/* <ViewProp length={6} /> */}
                </div>
                </div>
              </div>
            </div>
            <div className="self-stretch flex-col sm:flex-row justify-between items-start gap-4 inline-flex">
              {path === true ? null : 
                <button className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]" onClick={handlePreviousBTN}>
                  <span className="text-center text-orange-500 text-base font-semibold">
                  {language["previous_btn"]}
                  </span>
                </button>
              }
              <button className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]">
                <span
                  className="text-center text-white text-base font-semibold whitespace-nowrap"
                  onClick={handleEduNext}
                >
                  {language["save_n_continue"]}
                </span>
              </button>
            </div>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}